'use client';

import React from 'react';
// Import styles directly
import '@mantine/core/styles.css';

// This component will inject Mantine styles when mounted
export const StylesProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return <>{children}</>;
}; 